import { useState, useCallback } from 'react';
import { useNotificationContext } from '@/contexts/NotificationContext';
import { appRoutes } from 'app/routes/constants';
import { sendPasswordResetEmail } from 'firebase/auth';
import firebaseAuth from 'Modules/firebase/firebase-auth';
import { getOperatorTenantUrl } from "@/operator/utils/env/urlStrings";

export const useChangeUserPassword = () => {
    const { showNotification } = useNotificationContext();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);

    const changeUserPassword = useCallback(
        async (email: string, subdomain: string) => {
            setLoading(true);
            setError(null);

            const url = getOperatorTenantUrl();
            const actionCodeSettings = {
                url: `${url}${appRoutes.RESET_PASSWORD}`,
                handleCodeInApp: true,
            };

            try {
                await sendPasswordResetEmail(
                    firebaseAuth,
                    email,
                    actionCodeSettings,
                );

                showNotification({
                    message: 'Please check your email to manage your password.',
                    severity: 'success',
                });
            } catch (err) {
                console.error('Error:', err);
                setError(err);
                showNotification({
                    message: 'Something went wrong, please try again.',
                    severity: 'error',
                });
            } finally {
                setLoading(false);
            }
        },
        [],
    );

    return {
        changeUserPassword,
        changePasswordLoading: loading,
        changePasswordError: error,
    };
};
